import { createTheme } from "@material-ui/core";

export const defaultThemeOptions = {
  palette: {
    primary: {
      'main': "#02429C"
    }
  },
  props: {
    MuiCheckbox: {
      color: "primary"
    },
    MuiRadio: {
      color: "primary"
    },
    MuiSwitch: {
      color: "primary"
    },
    MuiList: {
      dense: true
    },
  },
  mapTab: {
    background: "#7cc3e1",
    iconColor: "#000",
    hover: {
      background: "#43a9d4"
    },
    selected: {
      background: "#43a9d4"
    },
    active: {
      background: '#216e8e',
      borderColor: '#216e8e'
    }
  },
  customCheckbox: {
    color: "#0474fe",
    offHover: '#f2f2ff'
  },
  customRadio: {
    color: "#0474fe",
    offHover: '#f2f2ff'
  },
  contentsInfo: {
    basetimeContainer: {
      background : 'rgba(128,128,128,.9)',
      color: '#fff8dc',
    }
  },
  legendBox: {
    background: "rgba(128, 128, 128, 0.9)",
    color: "rgb(255, 255, 255)"
  },
  message: {
    sendIcon: {
      background: "#434343ff",
      color: '#fff'
    },
    sendMessage: {
      background: "rgb(254, 209, 232)",
      color: "rgba(0, 0, 0, 0.87)"
    },
    receiveMessage: {
      background: "#A8DDFD",
      color: "rgba(0, 0, 0, 0.87)"
    }
  }
};
export const defaultTheme = createTheme(defaultThemeOptions);
